import bee from "./Bee"
export default {
    name: "Businesses",
    /*
        var query = {
            
        }
    */
    /* eslint-disable no-unused-vars */
    get_number_of_businesses(query, success, fail) {
        //nyd 
        //for now just do this
        bee.get({
            businesses: {
                _a: "_count"
            }
        })
            .then(res => {
                if (success) {
                    var num = res.businesses[0].count;//24567; 
                    success(num);
                }
            })
            .catch(errors => {
                if (fail) {
                    fail(errors);
                }
            });
    },
    /*
        var query = {
            user_id: 2
        }
    */
    /* eslint-disable no-unused-vars */
    get_my_buinesses(query, success, fail) {
        bee.get({
            businesses: {
                district:{},
                _ob: ["name"],
                _w: [
                    ["id", "e", query.user_id]
                ]
            }
        }).then(res => {
            if (success) {
                success(res.businesses);
            }
        }).catch(errors => {
            if (fail) {
                fail(errors);
            }
        });
    },
    /*
        var query = {
            user_id: 2
        }
    */
    /* eslint-disable no-unused-vars */
    get_register_business_dependencies(query, success, fail) {
        bee.get({
            businesses: {
                _ob: ["name"],
                _w: [
                    ["user_id", "e", query.user_id]
                ]
            },
            districts: {
                cities: {},
                wards: {
                    streets: {}
                }
            },
            categories: {
                sub_categories: {}
            }
        }).then(res => {
            if (success) {
                success({
                    businesses: res.businesses,
                    districts: res.districts,
                    categories: res.categories
                });
            }
        }).catch(errors => {
            if (fail) {
                fail(errors);
            }
        });
    },
    /*
        var query = {
            data: {},
            categories: [],
            is_added_by_admin: true
        }
    */
    /* eslint-disable no-unused-vars */
    post_my_business(query, success, fail) {
        var blngs = [];
        for (let index = 0; index < query.categories.length; index++) {
            var cat = query.categories[index];
            blngs.push({
                _fk_business_id: "business",
                sub_category_id: cat.id,
                category_id: cat.category_id,
                country_id: 1 //botswana
            });
        }
        //var msg_id = Math.random().toString().replace("0","") + "_" + (new Date()).getTime().toString();
        var data = {
            business: query.data,
            belongings: blngs
        };
        bee.post(data).then(res => {
            //send success messages and mobile phone android and ios notifications
            var message_data = {
                _box: {
                    user_id: query.data.user_id,
                    business_id: res.business,
                    is_added_by_admin: query.is_added_by_admin,
                    business_name: query.data.name
                },
                _f_br: "send_registration_success_messages"
            }
            bee.get(message_data).then(res2 => {
                if (success) {
                    success({
                        business: res.business,
                        belongings: res.belongings,
                        ...res2
                    });
                }
            }).catch(errors => {
                fail(["Business was registered but we faced errors while sending you messages"].concat(errors));
            });
        }).catch(errors => {
            if (fail) {
                fail(errors);
            }
        });
    },
    /*
        var query = {
            user_id: 2,
            id: 34
        }
    */
    /* eslint-disable no-unused-vars */
    get_my_business(query, success, fail) {
        bee.get({
            business: {
                user: {},
                district:{},
                city:{},
                ward: {},
                street: {},
                _w: [
                    ["id", "e", query.id]
                ]
            },
            belongings:{
                sub_category: {},
                category: {},
                _w: [
                    ["business_id", "e", query.id]
                ]
            },
            business_holliday_schedules:{
                holliday: {},
                _w: [
                    ["business_id", "e", query.id]
                ]
            },
            pictures:{
                _w: [
                    ["business_id", "e", query.id]
                ]
            },
            reviews:{
                _w: [
                    ["business_id", "e", query.id]
                ]
            },
            ratings:{
                _w: [
                    ["business_id", "e", query.id]
                ]
            },
            products:{
                _w: [
                    ["business_id", "e", query.id]
                ]
            },
            services:{
                _w: [
                    ["business_id", "e", query.id]
                ]
            },
            business_messages:{
                _w: [
                    ["business_id", "e", query.id]
                ]
            },
        }).then(res => {
            if (success) {
                success({
                    ... res.business,
                    belongings: res.belongings,
                    business_holliday_schedules: res.business_holliday_schedules,
                    pictures: res.pictures,
                    reviews: res.reviews,
                    ratings: res.ratings,
                    products: res.products,
                    services: res.services,
                    business_messages: res.business_messages,
                });
            }
        }).catch(errors => {
            if (fail) {
                fail(errors);
            }
        });
    },
}